<div class="cg" role="dialog" aria-modal="true" [attr.aria-label]="'Tomar foto de ' + (tituloCompleto || 'tu documento')">
  <!-- El video y el recuadro siempre están en el DOM: el recorte lee sus cajas. -->
  <video #video class="cg-video" [class.is-oculto]="estado !== 'lista'" autoplay muted playsinline></video>

  <div class="cg-guia" [class.is-oculto]="estado !== 'lista'">
    <div #marco class="cg-marco" [class.cg-marco--tarjeta]="guia === 'TARJETA'" [class.cg-marco--hoja]="guia === 'HOJA'"
         [class.cg-marco--pasaporte]="guia === 'PASAPORTE'" aria-hidden="true">
      <i class="cg-esquina cg-esquina--si"></i>
      <i class="cg-esquina cg-esquina--sd"></i>
      <i class="cg-esquina cg-esquina--ii"></i>
      <i class="cg-esquina cg-esquina--id"></i>
    </div>
    <p class="cg-instruccion">
      <strong>{{texto.texto}}</strong>
      <span>{{texto.consejo}}</span>
    </p>
    <p class="cg-lectura" [ngClass]="'cg-lectura--' + lectura" role="status" aria-live="polite">{{textoLectura[lectura]}}</p>
    <p class="cg-depuracion" *ngIf="depuracion">
      nitidez {{depuracion.nitidez | number:'1.0-0'}} · máx {{depuracion.maximo | number:'1.0-0'}} ·
      mov {{depuracion.movimiento === null ? '—' : (depuracion.movimiento | number:'1.1-1')}} · luz {{depuracion.brillo | number:'1.0-0'}}
    </p>
  </div>

  <div class="cg-destello" *ngIf="destello" aria-hidden="true"></div>

  <header class="cg-barra">
    <button #botonCerrar type="button" class="cg-icono" aria-label="Cerrar la cámara" (click)="cancelar()">
      <fa-icon [icon]="iconos.cerrar"></fa-icon>
    </button>
    <p class="cg-barra__titulo">
      <span>{{titulo}}</span>
      <strong *ngIf="etiqueta">{{etiqueta}}</strong>
    </p>
    <span class="cg-barra__espacio" aria-hidden="true"></span>
  </header>

  <!-- La foto se toma sola al enfocar; a mano, después de la espera (ESPERA_MANUAL_MS). -->
  <footer class="cg-pie" *ngIf="estado === 'lista'">
    <p class="cg-pie__nota">{{manualDisponible ? '¿No enfoca? Tómala tú' : 'Se toma sola al enfocar'}}</p>
    <button type="button" class="cg-disparador" [class.is-esperando]="!manualDisponible"
            [attr.aria-label]="manualDisponible ? 'Tomar foto' : 'Tomar foto (se toma sola al enfocar)'"
            [disabled]="procesando || !manualDisponible" (click)="tomarFoto()">
      <svg class="cg-anillo" viewBox="0 0 80 80" aria-hidden="true">
        <circle class="cg-anillo__pista" cx="40" cy="40" r="37"></circle>
        <circle class="cg-anillo__avance" cx="40" cy="40" r="37"
                [attr.stroke-dasharray]="circunferencia" [attr.stroke-dashoffset]="circunferencia * (1 - progresoAuto)"></circle>
      </svg>
      <span class="cg-disparador__centro"></span>
    </button>
  </footer>

  <div class="cg-panel" *ngIf="estado === 'abriendo'" role="status">
    <span class="cg-girando" aria-hidden="true"></span>
    <p class="cg-panel__titulo">Abriendo la cámara…</p>
    <p class="cg-panel__texto">Si el navegador lo pregunta, permite usar la cámara.</p>
  </div>

  <div class="cg-panel cg-panel--revision" *ngIf="estado === 'revisando' && vistaPrevia">
    <p class="cg-panel__titulo">¿Se lee bien?</p>
    <img class="cg-foto" [class.cg-foto--hoja]="guia === 'HOJA'" [src]="vistaPrevia" alt="Foto que tomaste">
    <p class="cg-aviso-revision" *ngIf="avisoRevision" role="status">{{avisoRevision}}</p>
    <p class="cg-panel__texto">Revisa que se vea completa, nítida y sin reflejos.</p>
    <div class="cg-acciones">
      <button type="button" class="cg-boton cg-boton--secundario" (click)="repetir()">
        <fa-icon [icon]="iconos.repetir"></fa-icon><span>Repetir</span>
      </button>
      <button type="button" class="cg-boton cg-boton--primario" (click)="usar()">
        <fa-icon [icon]="iconos.usar"></fa-icon><span>Usar foto</span>
      </button>
    </div>
  </div>

  <div class="cg-panel" *ngIf="estado === 'sin-camara'" role="alert">
    <span class="cg-panel__icono" aria-hidden="true"><fa-icon [icon]="iconos.camara"></fa-icon></span>
    <p class="cg-panel__titulo">No se abrió la cámara</p>
    <p class="cg-panel__texto">{{motivo}}</p>
    <div class="cg-acciones cg-acciones--columna">
      <button type="button" class="cg-boton cg-boton--primario" (click)="sinRecuadro()">
        <fa-icon [icon]="iconos.camara"></fa-icon><span>Tomar la foto sin recuadro</span>
      </button>
      <button type="button" class="cg-boton cg-boton--texto" (click)="cancelar()">Cancelar</button>
    </div>
  </div>
</div>
